<mat-form-field [appearance]="appearance" fxFlex *ngIf="!hasSelectedMaintenanceType">
  <mat-label *ngIf="floatLabel">{{ floatLabelText ? floatLabelText : ('MAINTENANCES.TYPES' | translate) }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [disabled]="disabled"
    [required]="required"
    placeholder="{{ 'MAINTENANCES.TYPES_PLACEHOLDER' | translate }}"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedMaintenanceType()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngIf="showAllAsAnOption && !maintenanceTypes.length" [value]="'allOptions'">
      {{ 'MAINTENANCES.ALL_MAINTENANCES' | translate }}
    </mat-option>
    <mat-option *ngFor="let maintenanceType of maintenanceTypes" [value]="maintenanceType.id">
      {{ maintenanceType.name }}
    </mat-option>
    <mat-option *ngIf="!maintenanceTypes.length">
      {{ 'MAINTENANCES.TYPES_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    {{ 'MAINTENANCES.TYPES_REQUIRED' | translate }}
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" fxFlex *ngIf="hasSelectedMaintenanceType">
  <mat-label *ngIf="floatLabel">{{ floatLabelText ? floatLabelText : ('MAINTENANCES.TYPES' | translate) }}</mat-label>

  <div class="flex">
    <input
      [ngClass]="{ 'archived-selected': selectedMaintenanceType?.archived }"
      type="text"
      matInput
      [value]="selectedMaintenanceType?.name || ('MAINTENANCES.ALL_MAINTENANCES' | translate)"
      disabled
      [required]="required"
    />

    <div class="archived-label" *ngIf="selectedMaintenanceType?.archived">
      <span>{{ 'MAINTENANCES.ARCHIVED' | translate }}</span>
    </div>
  </div>

  <button
    mat-icon-button
    matSuffix
    class="my-cancel-button accent-700-fg"
    (click)="deselectMaintenanceType()"
    [disabled]="disabled"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</mat-form-field>
